import { useRef, useEffect, useCallback } from 'react';

import {
  standardBlueprintVersion,
  POC_OTHER_BLUEPRINT_VERSION,
} from '../../../blueprint';
import { FeatureName } from '../../../utils';

import type { BlueprintVersion } from '../../../blueprint';
import type { UseFeatureHook } from '../../../types';

export function useGetBlueprintVersion(
  useFeature: UseFeatureHook
): () => Promise<BlueprintVersion> {
  const { isReady, treatment } = useFeature(
    FeatureName.CVR_CONSOLIDATE_ME_PAGES
  );

  const blueprintVersionPromiseRef = useRef(
    Promise.withResolvers<BlueprintVersion>()
  );

  useEffect(() => {
    if (isReady) {
      blueprintVersionPromiseRef.current.resolve(
        treatment === 'on'
          ? POC_OTHER_BLUEPRINT_VERSION
          : standardBlueprintVersion
      );
    }
  }, [isReady, treatment]);

  return useCallback(() => blueprintVersionPromiseRef.current.promise, []);
}
